export default __webpack_public_path__ + "static/proxima-nova-600-i-60f8ff43dc8e849774342befaab63bdd.woff2";